// src/data/dummyMagazine.js
const dummyMagazine = [
  {
    id: '1',
    title: "2022 Aralık Sayısı",
    mainPhoto: "https://istanbul.eestec.net/img/photos/deneme.jpg",
    url: "https://example.com/magazine1",
    pdfUrl: "gs://fir-4cb62.appspot.com/2022 Aralık_compressed.pdf" 
  },
  {
    id: '2',
    title: "2022 Ekim Sayısı",
    mainPhoto: "https://istanbul.eestec.net/img/photos/deneme.jpg",
    url: "https://example.com/magazine2",
    pdfUrl: "gs://fir-4cb62.appspot.com/2022 Ekim.pdf" 
  },

  {
    id: '3',
    title: "2022 Aralık Sayısı",
    mainPhoto: "https://istanbul.eestec.net/img/photos/deneme.jpg",
    url: "https://example.com/magazine1",
    pdfUrl: "gs://fir-4cb62.appspot.com/2022 Aralık_compressed.pdf" 
  },
  {
    id: '4',
    title: "2022 Ekim Sayısı",
    mainPhoto: "https://istanbul.eestec.net/img/photos/deneme.jpg",
    url: "https://example.com/magazine2",
    pdfUrl: "gs://fir-4cb62.appspot.com/2022 Ekim.pdf" 
  },
];

export default dummyMagazine;
